// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialSharing__container"};